export default "__VITE_ASSET__D5mItxvj__"